export default function Sizebasket() {
            return function(scope, element) {
                const sizeWindow = angular.element(window);
                const changeHeight = function() {
                    element.css('max-height', (sizeWindow.height() - 73) + 'px');
                };
                sizeWindow.bind('sizebasket', function() {
                    // when window size gets changed
                    changeHeight();
                });

                // when page loads
                changeHeight();
            };
}



// WEBPACK FOOTER //
// ./src/app/modules/main/directives/sizeBasket.directive.js